<template>
  <div id="contents" class="service-intro">
    <div class="inner">
      <h3 class="main-title">서비스소개</h3>
      <ul class="tab-wrap">
        <li><a href="/service/hometown" class="tab-btn active">SKB 우리동네광고</a></li>
        <li><a href="/service/skylife" class="tab-btn">KT스카이라이프 IPTV광고</a></li>
        <li><a href="/service/experience" class="tab-btn">체험단 마케팅</a></li>
        <li><a href="/service/reporter" class="tab-btn">기자단 마케팅</a></li>
        <li><a href="/service/insta" class="tab-btn">인스타 마케팅</a></li>
        <li><a href="/service/viral" class="tab-btn">바이럴 마케팅</a></li>
      </ul>
    </div>
    <div class="service-intro-wrap intro01">
      <section class="sec01">
        <div class="inner flexbox">
          <div class="title-wrap">
            <h4 class="section-title">950만 가입자에게 우리 가게 홍보</h4>
            <p class="section-desc">저렴한 비용으로 전국 TV광고를 할 수 있는 소상공인 전용 광고 상품입니다.<br/>
              동 단위의 지역 타겟팅이 가능하여 원하는 지역만 선택해 광고할 수 있습니다.</p>
          </div>
          <img src="../resource/images/service-btv-logo.png" alt="btv"/>
        </div>
      </section>
      <section class="sec02">
        <div class="inner">
          <ul class="list type-btn">
            <li>
                <span class="round-box">
                  <img src="../resource/images/ico_service_intro01.png" alt=""/>
                  SK브로드밴드 <span class="tx-blue">공식 광고대행사</span>
                </span>
            </li>
            <li>
                <span class="round-box">
                  <img src="../resource/images/ico_service_intro02.png" alt=""/>
                  방송통신위원회 2022년도 방송평가 MSO 분야&nbsp;<span class="tx-blue">3년 연속 1위</span>
                </span>
            </li>
            <li>
                <span class="round-box">
                  <img src="../resource/images/ico_service_intro03.png" alt=""/>
                  <span class="tx-blue">가입자수 950만</span>에게 홍보
                </span>
            </li>
            <li>
                <span class="round-box">
                  <img src="../resource/images/ico_service_intro04.png" alt=""/>
                  <span class="tx-blue">다양한 채널</span>에서의 광고
                </span>
            </li>
          </ul>
        </div>
      </section>
      <section class="sec03">
        <div class="inner">
          <ul class="info-list-line">
            <li>
              <h4 class="info-title">950만 가입고객의 초대형 TV 플랫폼</h4>
              <p class="section-desc">가입자를 보유한 초대형 TV 플랫폼 B TV는 IPTV 3사 중 압도적으로 높은 가입자를 보유하고 있습니다. 이러한 데이터 베이스를 통해 가망 고객이 있는 원하는 지역과 관심 채널로 타겟팅을 설정하고, 효율적인 비용 설정이 가능해 소상공인분들도 부담 없이 우리 매장만의 TV 광고를 진행할 수 있습니다.</p>
            </li>
            <li>
              <h4 class="info-title">가성비 높은 B tv 광고</h4>
              <p class="section-desc">우리동네 B tv 광고는 완전 시청 시 과금하는 True view 방식으로, 경제적이고 효율적인 광고 집행이 가능합니다. 1회당 5원~10원의 가격으로 시청률 상위 86개 채널에 효과적으로 노출되며, 무료 광고 제작 템플릿/맞춤 영상 제작 시스템으로 계약부터 영상 제작, 광고집행까지 쉽고 간편한 진행이 가능합니다.</p>
            </li>
            <li>
              <h4 class="info-title">실시간 광고 분석 리포팅</h4>
              <p class="section-desc">광고가 집행된 후 일자별 / 지역별 노출 데이터를 확인할 수 있습니다. 채널별 노출현황부터 Real Time 조회까지 우리 매장 TV 광고의 도달 데이터를 확인하고 분석하여 더 전략적인 광고 집행이 가능합니다. 원하는 지역, 원하는 가망고객들에게 지속적이고 반복적인 노출로 브랜드 인지도와 매출 상승까지 두 가지를 모두 잡아보세요!</p>
            </li>
          </ul>
        </div>
      </section>
      <section class="sec04">
        <div class="inner small">
          <h4 class="section-sub-title">샘플 영상</h4>
          <div class="video">
            <video controls style="width:100%; height:100%; ">
              <source src="../resource/data/skb.mp4" type="video/mp4"/>
            </video>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>

export default {
  name: 'page-hometown',
  components: {

  },
  data () {
    return {
      curWidth: 2.5
    }
  },
  mounted() {
    if (document.body.clientWidth < 800) {
      this.curWidth = 1
    }
    document.body.classList.add('sub');
    this.scroll();
  },
  methods: {
    scroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || window.screenY;
      document.querySelectorAll("section").forEach(item => {
        if(scrollTop > item.offsetTop - window.innerHeight / this.curWidth){
          item.classList.add("on");
        }
      });
      window.requestAnimationFrame(this.scroll);
    }
  }
}

</script>